<template>
  <div test-id="notification_settings">
    <div v-for="(settings, mainIdx) in localSettings" :key="settings.name">
      <div
        v-for="(section, sectionIdx) in settings.sections"
        :key="section.name"
        class="notification-section"
      >
        <div class="heading-text">
          <p class="main-heading has-text-weight-bold">{{ section.name }}</p>
          <p class="sub-heading">(one or more is required)</p>
        </div>
        <div class="controls">
          <div
            v-for="(property, idx) in section.properties"
            :key="property.key"
            :class="['control', { 'bottom-border': idx !== section.properties.length - 1 }]"
          >
            <p class="item-label">{{ property.name.en }}</p>
            <LsSwitch
              v-model="property.is_enabled"
              :disabled="disableSwitch({ mainIdx, sectionIdx, idx })"
              :track-id="`notification_settings-${property.key}`"
              @input="toggleOption"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LsSwitch } from '@/components/common';
import { mapActions } from 'vuex';
import { PROFILE__UPDATE_NOTIFICATION_PREFERENCE } from '@/store/types';
import _ from 'lodash';

export default {
  name: 'NotificationSettings',
  components: { LsSwitch },
  data() {
    return {
      localSettings: _.cloneDeep(this.$store.state.auth.user.customer.settings),
    };
  },
  methods: {
    ...mapActions([PROFILE__UPDATE_NOTIFICATION_PREFERENCE]),
    toggleOption() {
      this[PROFILE__UPDATE_NOTIFICATION_PREFERENCE]({
        settings: [...this.localSettings],
      });
    },
    disableSwitch({ mainIdx, sectionIdx, idx }) {
      const currentSection = _.get(
        this.localSettings,
        this.getSectionPath({ mainIdx, sectionIdx })
      );
      const currentProperty = _.get(
        this.localSettings,
        this.getPropertyPath({ mainIdx, sectionIdx, idx })
      );
      const countOfEnabled = _.size(_.filter(currentSection.properties, { is_enabled: true }));
      //require at least one to be enabled
      return countOfEnabled < 2 && currentProperty.is_enabled;
    },
    getSectionPath({ mainIdx, sectionIdx }) {
      return `[${mainIdx}].sections[${sectionIdx}]`;
    },
    getPropertyPath({ mainIdx, sectionIdx, idx }) {
      const sectionPath = this.getSectionPath({ mainIdx, sectionIdx });
      return `${sectionPath}.properties[${idx}]`;
    },
  },
};
</script>

<style lang="scss" scoped>
.notification-section {
  padding: 20px 0;
  border-bottom: 1px solid $primary-light;
}
.heading-text {
  display: flex;
  padding-bottom: 10px;
}

.sub-heading {
  padding-left: 4px;
  font-size: $size-6;
}

.control {
  padding: 14px 0 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bottom-border {
  border-bottom: 1px solid $primary-light;
}
.themed-app {
  .notification-section {
    border-color: $theme-color-primary-light;
  }
  .sub-heading {
    font-size: $theme-txt-body-sm;
  }

  .bottom-border {
    border-color: $theme-color-primary-light;
  }
}
</style>
